import Button, { ButtonPrev } from '../../../../../UI/Button'
import s from './index.module.css'


const arHistory = [
  {
    date: '10 февраля 2021',
    theme: 'Реферальная программа',
    sum: '700 рублей'
  },
  {
    date: '10 февраля 2021',
    theme: 'Реферальная программа',
    sum: '600 рублей'
  },
  {
    date: '10 февраля 2021',
    theme: 'Реферальная программа',
    sum: '500 рублей'
  },
  {
    date: '10 февраля 2021',
    theme: 'Реферальная программа',
    sum: '700 рублей'
  },
]


const AccrualHistory = ({ setTab }) => {
  return <>
    <ButtonPrev onClick={() => setTab('List')} />

    <ul className={s.list}>
      <li className={s.item}>
        <span className={s.boobleHead}>Дата</span>
        <span className={s.boobleHead}>Сумма</span>
        <span className={s.boobleHead}>Подтверждающий документ</span>
      </li>
      {arHistory.map((el, index) => <li key={index} className={s.item}>
        <span className={s.boobleVal}>{el.date}</span>
        <span className={s.boobleVal}>{el.sum}</span>
        <Button styles='accent'>Скачать</Button>
      </li>)}
    </ul>

  </>
}


export default AccrualHistory
